/**
 * External Dependencies
 */
import 'jquery';
import './partials/navigation';

// Load in tiny NPM dependency to generate vendor.js
var hasValue = require('has-value');

$(document).ready(() => {
  // console.log('Hello world');
});
